/** Inline SVG sprite for the iCons brand mark + the Fibonacci-circle
 *  background ornaments that frame both the login screen and the app
 *  shell. Mounted once in App.tsx so every <use href="#icons-logo">
 *  resolves. */

import type { JSX } from "preact";

/** SVG sprite — defines symbols referenced via `<svg><use href="#…"/></svg>`. */
export function BrandSprite(): JSX.Element {
  return (
    <svg width="0" height="0" style="position:absolute" aria-hidden="true">
      <defs>
        <symbol id="icons-logo" viewBox="0 0 850.4 141.7">
          <path d="M280.9,103.3l20.1,16.5c-12.4,14.2-28.9,21.8-51.7,21.8 c-40.5,0-71.2-31.9-71.2-70.9S208.9,0,249.3,0C272,0,288.6,7.7,301,21.9l-20.1,16.5c-6.5-6.8-14.8-12.4-31.6-12.4 c-24.5,0-42.8,20.7-42.8,44.9s18.3,44.9,42.8,44.9C266.1,115.8,274.4,110.1,280.9,103.3z M850.4,98.6c0,25.7-22.7,43.1-54,43.1 c-36.6,0-53.7-16.8-59.3-22.4l14.2-20.7c8.3,8,19.2,16.8,43.4,17.1c21.3,0.3,27.5-9.4,27.5-15.7c0-7.1-3.2-13.9-25.4-17.4 c-41.9-6.8-52.6-21.8-52.6-43.4C744.1,18,761.2,0,796.1,0c19.8,0,34.5,5.9,45.2,13.6L828,34.2c-7.4-4.4-17.2-8.2-31.9-8.2 c-17.7,0-23.6,5.9-23.6,12.4c0,7.4,5,13,28.6,15.9C843,59.7,850.4,81.2,850.4,98.6z M73.2,113.4v-85h40.2v-26H4.7v26h40.2v85H0v26 h118.1v-26H73.2z M675.6,2.4h-28.3v89.1L580.9,2.4h-23.4v137h28.3V52.1l64.9,87.2h24.8V2.4z M425.2,0c-39.1,0-70.9,31.7-70.9,70.9 c0,39.1,31.7,70.9,70.9,70.9c39.1,0,70.9-31.7,70.9-70.9c0,0,0,0,0,0C496.1,31.7,464.3,0,425.2,0z" />
        </symbol>
      </defs>
    </svg>
  );
}

/** Inline iCons wordmark <use> — referenced by the header + login card. */
export function IconsLogo({ className = "" }: { className?: string }): JSX.Element {
  return (
    <span class={`icons-logo${className ? ` ${className}` : ""}`} role="img" aria-label="ICONS">
      <svg aria-hidden="true" focusable="false">
        <use href="#icons-logo" />
      </svg>
    </span>
  );
}

/** Fibonacci concentric-circle ornament — fills the page background
 *  with two rotated clusters per the brand manual (p. 15–17). Decorative;
 *  hidden from assistive tech. */
export function BgPattern(): JSX.Element {
  return (
    <div class="bg-pattern" aria-hidden="true">
      <svg class="c-tl" viewBox="0 0 500 500">
        <g transform="translate(250 250)">
          <circle r="466" /><circle r="288" /><circle r="178" class="accent" />
          <circle r="110" /><circle r="68" /><circle r="42" class="accent" />
          <circle r="26" /><circle r="16" /><circle r="10" class="accent" />
          <circle r="6" /><circle r="4" />
          <circle class="dot" r="3" />
        </g>
      </svg>
      <svg class="c-br" viewBox="0 0 500 500">
        <g transform="translate(250 250) rotate(21)">
          <circle r="466" /><circle r="288" class="accent" /><circle r="178" />
          <circle r="110" class="accent" /><circle r="68" /><circle r="42" />
          <circle r="26" class="accent" /><circle r="16" /><circle r="10" />
          <circle r="6" /><circle r="4" class="accent" />
          <circle class="dot" r="3" />
        </g>
      </svg>
    </div>
  );
}
